import React from 'react';
import { ReactComponent as ReporterManager } from '../../assets/images/icons/reporter-manager.svg';

export default function ReporterManagerIcon(props) {
  return (
    <ReporterManager {...props} className={'icon'} />
  );
}
